import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar, Container } from 'react-bootstrap';
import logo from '../../assets/logo.png';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    
    // Simple admin authentication (can be enhanced later)
    if (credentials.username === 'admin' && credentials.password === 'startidbits2024') {
      localStorage.setItem('adminAuth', 'true');
      navigate('/admin/dashboard');
    } else {
      setError('Invalid credentials');
    }
  };

  return (
    <>
      {/* Main Navigation */}
      <Navbar 
        expand="lg" 
        className="animated-nav-background"
        style={{ 
          boxShadow: '0 2px 10px rgba(232, 12, 129, 0.2)',
          padding: '1rem 0',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(232, 12, 129, 0.1)'
        }}
        variant="dark"
      >
        <Container>
          <Navbar.Brand href="/">
            <img 
              src={logo} 
              alt="Star Tidbits" 
              style={{ 
                height: '60px', 
                width: 'auto',
                maxWidth: '100%'
              }}
            />
          </Navbar.Brand>
          <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
            <h3 style={{ color: 'white', margin: 0, fontSize: '1.25rem' }}>Admin Login</h3>
          </div>
        </Container>
      </Navbar>
      
      <div style={{ 
        minHeight: 'calc(100vh - 80px)', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        backgroundColor: 'var(--neutral-light)'
      }}>
      <div className="card" style={{ width: '400px', padding: '2rem' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '2rem', color: 'var(--primary-saffron)' }}>
          Admin Login
        </h2>
        
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>
              Username
            </label>
            <input
              type="text"
              value={credentials.username}
              onChange={(e) => setCredentials({...credentials, username: e.target.value})}
              style={{ 
                width: '100%', 
                padding: '0.75rem', 
                borderRadius: '6px', 
                border: '1px solid #ddd',
                fontSize: '1rem'
              }}
              required
            />
          </div>
          
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>
              Password
            </label>
            <input
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({...credentials, password: e.target.value})}
              style={{ 
                width: '100%', 
                padding: '0.75rem', 
                borderRadius: '6px', 
                border: '1px solid #ddd',
                fontSize: '1rem'
              }}
              required
            />
          </div>
          
          {error && (
            <div style={{ 
              color: '#f44336', 
              marginBottom: '1rem', 
              textAlign: 'center',
              fontSize: '0.875rem'
            }}>
              {error}
            </div>
          )}
          
          <button 
            type="submit" 
            className="btn btn-primary" 
            style={{ width: '100%', padding: '0.875rem' }}
          >
            Login to Admin Panel
          </button>
        </form>
        </div>
      </div>
    </>
  );
};

export default AdminLogin;